import { trpc } from '@/config/trpc'
import { useSidebarStore } from '@/stores/sidebarStore'
import { SidebarHeader } from './sidebar-header'
import { SidebarFooter } from './sidebar-footer'
import { SidebarNavigationListWorkspace } from './sidebar-navigation/sidebar-navigation-list-workspace'
import { SidebarNavigationListItem } from './sidebar-navigation/sidebar-navigation-list-item'
import { useUserContext } from '@/context/userLogin'
import env from '@/config/env'

export function Sidebar() {
  const { isOpen } = useSidebarStore()
  const { user } = useUserContext()

  const { data: subscription, isLoading: isSubscriptionLoading } =
    trpc.userSubscription.get.useQuery(undefined, {})
  const { data: remainingUsage, isLoading: isRemainingGenerationsLoading } =
    trpc.usageLimit.get.useQuery(undefined, {})

  const hasActiveSub = subscription && subscription.isSubscribed === true ? subscription : undefined
  const plan = hasActiveSub ? hasActiveSub.tier : 'free'
  const isCanceled = hasActiveSub?.source === 'stripe' ? !!hasActiveSub.isCanceled : false
  const currentPeriodEnd =
    hasActiveSub?.source === 'stripe' ? hasActiveSub.currentPeriodEnd : undefined
  const isTrial = hasActiveSub?.isTrial ?? false
  const trialExpiresAt = hasActiveSub?.expiresAt ?? undefined
  const hadTrial = subscription && !subscription.isSubscribed ? subscription.hadTrial : false

  return (
    <aside
      className={`bg-background fixed inset-y-0 left-0 z-30 flex h-dvh w-full transform gap-1.5 p-3 md:w-64 ${isOpen ? 'translate-x-0' : '-translate-x-full'} border-border flex flex-col justify-between border-r transition-transform duration-300 ease-in-out`}>
      <div className="flex min-h-0 flex-1 flex-col gap-1.5 overflow-y-auto">
        <SidebarHeader />

        <SidebarNavigationListItem
          items={[
            { label: 'Moodboards', to: '/moodboards' },
            { label: 'Automations', to: '/automations' },
            { label: 'My Posts', to: '/posts' },
            { label: 'Analytics', to: '/analytics' },
            user?.isAdmin || env.MODE !== 'production'
              ? { label: 'Campaigns', to: '/campaign' }
              : null,
            // Brand-specific config (brand details + social connections).
            { label: 'Settings', to: '/settings' },
          ].filter((e) => e !== null)}
        />

        <p className="">Posts</p>

        <SidebarNavigationListWorkspace />
      </div>
      {/* Account is user-level (brand-agnostic), so it sits at the bottom, apart
          from the brand-scoped nav above. */}
      <SidebarNavigationListItem items={[{ label: 'Account', to: '/account' }]} showAdmin={false} />
      <SidebarFooter
        plan={plan}
        isCanceled={isCanceled}
        currentPeriodEnd={currentPeriodEnd}
        remainingUsage={remainingUsage}
        isUserSubscribedLoading={isSubscriptionLoading}
        isRemainingGenerationsLoading={isRemainingGenerationsLoading}
        isTrial={isTrial}
        trialExpiresAt={trialExpiresAt}
        hadTrial={hadTrial}
      />
    </aside>
  )
}
